<template>
  <div>
    <div
      style="position: fixed; top: 20px; z-index: 1; backdrop-filter: blur(2px)"
      v-if="LoaderStatus"
    >
      <Spinner />
    </div>

    <div class="main-container">
      <div
        class="
          dashboardAdmin-header
          d-flex
          align-items-center
          justify-content-between
        "
      >
        <div class="d-flex align-items-center">
          <div>
            <img
              src="../../assets/img/feedbackform/backarrow.svg"
              class="pointer"
              @click="gobackpointer"
              alt=""
            />
          </div>
          <div class="dashboardAdmin-header-main-head ml-2">
            <span>{{ getIPName }}</span>
          </div>
        </div>
        <div
          class="position-relative newprimarybtn pointer"
          v-if="
            (getThirdPartyData.configuration.jobApprovalStage != 'BASIC_INFO' &&
              (getCustomerDetail.lead || getCustomerDetail.manager) &&
              roles.includes('PUSH_JOB')) ||
            (roles.includes('PUSH_JOB') &&
              getThirdPartyData.configuration.jobApprovalStage ==
                'BASIC_INFO' &&
              getCustomerDetail.manager)
          "
          ref="addJobToggle"
          v-closable="{
            exclude: ['addJobToggle'],
            handler: 'hideAddJobToggle',
          }"
        >
          <b-button
            style="padding: 3px 35px 3px 50px"
            class="w-100 d-flex align-items-center justify-content-center"
            @click="addJobToggle = !addJobToggle"
          >
            <span> Job </span>
            <img
              class="ml-2"
              :src="
                addJobToggle
                  ? require('../../assets/img/whiteuparrow.svg')
                  : require('../../assets/img/whitedownarrow.svg')
              "
              alt=""
            />
          </b-button>
          <div class="wb-ihd-plusbtn" @click="addJobToggle = !addJobToggle">
            <img
              src="../../assets/img/newworkbench/internalhiring/plusbtn.svg"
              alt=""
              class="mr-2"
            />
          </div>
          <div v-if="addJobToggle" class="addJobToggle-dropdown">
            <div
              class="pointer unselOption"
              @click="(addJobToggle = false), goToNewJob()"
            >
              <img
                class="mr-2"
                src="../../assets/talentpool/boldPlus.svg"
                alt=""
              />
              Create Manually
            </div>
            <div
              class="pointer unselOption"
              @click="(addJobToggle = false), (showUploadJD = true)"
            >
              <img
                class="mr-2"
                src="../../assets/talentpool/uploadTray.svg"
                alt=""
              />
              Upload JD
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex mt-2 h-90">
        <div
          class="wb-new-container p-0"
          :class="{
            'relativeclass w-100': jobList.length == 0 && searchQuery == '',
            'w-70': !(jobList.length == 0 && searchQuery == ''),
            'overflow-auto p-0': gridView === false && jobList.length,
          }"
        >
          <div
            class="d-flex align-items-center mb-2 padding10px"
            :class="
              jobList.length && !gridView
                ? 'IHD-table-minwidth justify-content-between'
                : !jobList.length && searchQuery === ''
                ? 'justify-content-end'
                : jobList.length && searchQuery === ''
                ? 'justify-content-between'
                : 'justify-content-between'
            "
          >
            <div
              class="fw-bold wb-subheading w-50"
              v-if="
                jobList.length != 0 ||
                (jobList.length == 0 && searchQuery != '')
              "
            >
              List of Jobs
            </div>
            <div
              class="d-flex gap-10 align-items-center"
              v-if="
                !(
                  searchQuery == '' &&
                  jobList.length == 0 &&
                  !LoaderStatus &&
                  ($route.query.itype == 'Active' ||
                    $route.query.itype == 'All') &&
                  $route.query.wtype == 1
                )
              "
            >
              <div class="view-toggle mt-1">
                <div v-if="gridView" class="d-flex gap-10 pointer">
                  <img
                    @click="gridView = true"
                    src="@/assets/New-imgs/switch/grid-view.svg"
                  />
                  <img
                    class="pr-1"
                    @click="setGridView(false)"
                    src="@/assets/New-imgs/switch/list-grid-view.svg"
                  />
                </div>
                <div v-else class="d-flex gap-10 pointer">
                  <img
                    class="pl-1"
                    @click="setGridView(true)"
                    src="@/assets/New-imgs/switch/grid-list-view.svg"
                  />
                  <img
                    @click="gridView = false"
                    src="@/assets/New-imgs/switch/list-view.svg"
                  />
                </div>
              </div>

              <div
                :class="
                  jobList.length == 0 ? 'w-100  d-flex justify-content-end' : ''
                "
                class="bluebtn position-relative"
                v-closable="{
                  exclude: ['filter-btn', 'filter-box'],
                  handler: 'hideFilterBox',
                }"
              >
                <div class="IHD-filter-count mb-3" v-if="filterApplied"></div>
                <b-button
                  class="acs-addBtn"
                  @click="
                    (openFilter = !openFilter),
                      (reset = false),
                      (sortCard = false),
                      (typeCard = false);
                    resetFilter();
                  "
                  ><img
                    class="mr-2"
                    src="../../assets/img/accessconnew/whiteFilter.svg"
                    alt=""
                  />Filter</b-button
                >
                <div
                  style="top: 35px; right: 0px"
                  v-if="openFilter"
                  class="acs-filter p-3"
                  ref="filter-box"
                >
                  <div>
                    <div>
                      <div class="acs-black-txt">Sort By :</div>
                      <div
                        @click="(sortCard = !sortCard), (typeCard = false)"
                        class="
                          acs-filter-dropdown
                          mt-2
                          position-relative
                          pointer
                        "
                      >
                        <span class="newManage-dropdown-place">
                          {{ sortName }}
                        </span>
                        <img
                          v-if="!sortCard"
                          class="mr-2"
                          src="../../assets/img/accessconnew/blueDownArrowSmall.svg"
                          alt=""
                        />
                        <img
                          v-else
                          class="mr-2"
                          src="../../assets/img/accessconnew/uparrow-blue-small.svg"
                          alt=""
                        />
                      </div>
                      <div v-if="sortCard" class="relativeclass">
                        <div
                          class="newInt-radio-dropdown p-0 filter-drop-height"
                        >
                          <b-form-group class="sec-mcq-datacard">
                            <b-form-radio-group
                              class="newInt-radio-dropdown-inner-content w-100"
                              size="sm"
                              v-model="sortSelected"
                              :options="sortOptions"
                              @change="sortCard = false"
                              buttons
                              stacked
                            >
                            </b-form-radio-group>
                          </b-form-group>
                        </div>
                      </div>
                    </div>
                    <div
                      class="mt-3"
                      v-if="getCustomerDetail.lead || getCustomerDetail.manager"
                    >
                      <div class="acs-black-txt">Job Status :</div>
                      <div
                        @click="(typeCard = !typeCard), (sortCard = false)"
                        class="
                          acs-filter-dropdown
                          mt-2
                          position-relative
                          pointer
                        "
                      >
                        <span class="newManage-dropdown-place">
                          {{ jdtypeselectedtext }}
                        </span>
                        <img
                          v-if="~typeCard"
                          class="mr-2"
                          src="../../assets/img/accessconnew/blueDownArrowSmall.svg"
                          alt=""
                        />
                        <img
                          v-else
                          class="mr-2"
                          src="../../assets/img/accessconnew/uparrow-blue-small.svg"
                          alt=""
                        />
                      </div>
                      <div v-if="typeCard" class="relativeclass">
                        <div
                          class="newInt-radio-dropdown p-0 filter-drop-height"
                        >
                          <b-form-group class="sec-mcq-datacard">
                            <b-form-radio-group
                              class="newInt-radio-dropdown-inner-content w-100"
                              size="sm"
                              v-model="jdtypeselected"
                              :options="filteredJdTypeOptions"
                              @change="typeCard = false"
                              buttons
                              stacked
                            >
                            </b-form-radio-group>
                          </b-form-group>
                        </div>
                      </div>
                    </div>
                    <div class="bluebtn d-flex justify-content-between mt-4">
                      <b-button
                        class="acs-cancelBtn-filter"
                        @click="
                          (reset = false), (openFilter = false), resetFilter()
                        "
                        >Cancel</b-button
                      >
                      <div class="d-flex">
                        <b-button
                          class="acs-cancelBtn-filter mr-3"
                          @click="(reset = true), resetFilter()"
                          >Reset</b-button
                        >
                        <b-button
                          class="acs-cancelBtn-filter"
                          @click="(filterApplied = true), saveSort()"
                          >Apply</b-button
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <hr
            :class="{ 'IHD-table-minwidth margin10px': gridView === false }"
            class="my-0"
            v-if="
              jobList.length != 0 || (jobList.length == 0 && searchQuery != '')
            "
          />

          <div
            v-if="
              (gridView ||
                ($route.query.gridView && $route.query.gridView === 'true')) &&
              jobList.length
            "
          >
            <GridView
              :jobList="jobList"
              @onScroll="onScroll"
              @getJobDetails="getJobDetails"
              @getJobs="getJobs"
              @deselectJob="deselectJob"
              :selectedJD="selectedJD"
              @resetPagination="resetPagination"
              :gridView="true"
            />
          </div>
          <div
            v-else-if="
              (!gridView ||
                ($route.query.gridView && $route.query.gridView === 'false')) &&
              jobList.length
            "
          >
            <ListView
              :jobList="jobList"
              @onScroll="onScroll"
              @getJobDetails="getJobDetails"
              @getJobs="getJobs"
              :selectedJD="selectedJD"
              @deselectJob="deselectJob"
              @resetPagination="resetPagination"
              :gridView="false"
            />
          </div>
          <div
            class="d-flex flex-column align-items-center justify-content-center"
            style="height: calc(100vh - 230px)"
            v-if="
              searchQuery !== '' &&
              searchQuery != 'Loader' &&
              jobList.length === 0
            "
          >
            <div>
              <img
                src="../../assets/img/accessconnew/emptyprivilageBig.svg"
                alt=""
              />
            </div>
            <div class="mt-3 w-100 text-center">
              <span class="searchnotfound"
                >No matching results for
                <span class="searchtext wordbreak"> "{{ searchQuery }}" </span>
                .</span
              >
            </div>
          </div>
          <div
            v-if="
              searchQuery == '' &&
              jobList.length == 0 &&
              !LoaderStatus &&
              ($route.query.itype == 'Active' || $route.query.itype == 'All') &&
              $route.query.wtype == 1
            "
            class="
              d-flex
              flex-column
              align-items-center
              justify-content-center
              h-90
              w-100
            "
          >
            <div class="">
              <img src="../../assets/nojob.svg" alt="" />
            </div>
            <div
              class="teams-empty-container-font"
              v-if="
                (getThirdPartyData.configuration.jobApprovalStage !=
                  'BASIC_INFO' &&
                  getCustomerDetail.lead &&
                  roles.includes('PUSH_JOB')) ||
                (roles.includes('PUSH_JOB') &&
                  getThirdPartyData.configuration.jobApprovalStage ==
                    'BASIC_INFO' &&
                  !getCustomerDetail.manager)
              "
            >
              There are no jobs
            </div>
            <div class="teams-empty-container-font" v-else>
              There are no jobs Please click <strong> "+ Job" </strong>
              button to create
            </div>
          </div>
          <div
            v-else-if="
              page == 0 &&
              searchQuery == '' &&
              jobList.length == 0 &&
              !LoaderStatus
            "
            class="
              d-flex
              flex-column
              align-items-center
              justify-content-center
              h-90
              w-100
            "
          >
            <div class="">
              <img
                src="../../assets/img/newworkbench/internalhiring/inactive-jd.svg"
                alt=""
              />
            </div>
            <div class="teams-empty-container-font">
              There are no "{{ jobStatus }}" jobs
            </div>
          </div>
        </div>

        <div
          class="wb-new-container w-30 ml-2"
          v-if="
            jobList.length != 0 || (jobList.length == 0 && searchQuery != '')
          "
        >
          <div
            class="ihd-jobdeatils h-90 overflow-auto"
            v-if="!selectedJD && (!rmConfig || rmList.length == 0)"
          >
            <div
              class="
                d-flex
                align-items-center
                flex-column
                h-90
                justify-content-center
              "
            >
              <img
                src="../../assets/img/newworkbench/internalhiring/emptyicon.svg"
                alt=""
              />
              <div class="pff-right-empty-txt">
                Click on the eye icon to view <br />
                Job Details
              </div>
            </div>
          </div>
          <section v-else-if="!selectedJD && rmConfig && rmList.length != 0">
            <section
              class="
                d-flex
                align-items-center
                justify-content-between
                mt-2
                ml-2
              "
            >
              <div class="newInt-rs-mainhead">
                <img
                  src="../../assets/img/settings-norwin-icon.svg"
                  class="mr-1"
                  alt=""
                />
                List of Regional Manager
              </div>
              <!-- style bind with opacity: 0.5; if it is disabled -->
              <div
                class="clear-font pointer mr-2"
                @click="
                  selectedRMs.length != 0 ? ((selectedRMs = []), getJobs()) : ''
                "
                :class="selectedRMs.length == 0 && 'disabled-access-img'"
              >
                Clear
              </div>
            </section>
            <hr />
            <section class="w-100 reg-header d-flex align-items-center">
              <div class="w-50">Name</div>
              <div class="w-25 text-center">Total Jobs</div>
              <div class="w-25 text-center">Total Positions</div>
            </section>

            <section class="mt-3 reg-body-overflow">
              <!-- once selected bind this class common-selected-card -->
              <section
                @click="selectRM(rm._id)"
                :class="{
                  'common-selected-card': selectedRMs.includes(rm._id),
                  'mb-1': index == rmList.length - 1,
                }"
                class="
                  common-white-card
                  reg-body
                  pointer
                  d-flex
                  w-100
                  mb-3
                  px-1
                "
                v-for="(rm, index) in rmList"
                :key="rm._id"
              >
                <!-- for last index mb-3 should not get applied mb-1 should get applied -->
                <b-card class="w-100">
                  <div class="w-50 text-truncate">{{ rm.regionalManager }}</div>
                  <div
                    class="
                      w-25
                      justify-content-center
                      text-truncate text-center
                      d-flex
                      align-items-center
                    "
                  >
                    <div class="text-truncate">{{ rm.totalJobs }}</div>
                    <div
                      class="
                        rounded-cirlces-main
                        d-flex
                        align-items-center
                        ml-1
                      "
                    >
                      <img src="../../assets/img/newkanban/greencircle.svg" />
                      <div class="rounded-cirlces-font">
                        {{ rm.activeJobs }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="
                      w-25
                      justify-content-center
                      text-center
                      d-flex
                      align-items-center
                      ml-1
                    "
                  >
                    <div class="text-truncate">{{ rm.totalPositions }}</div>
                    <div
                      class="
                        rounded-cirlces-main
                        d-flex
                        align-items-center
                        ml-1
                      "
                    >
                      <img src="../../assets/img/newkanban/greencircle.svg" />
                      <div class="rounded-cirlces-font">
                        {{ rm.activePositions }}
                      </div>
                    </div>
                  </div>
                </b-card>
              </section>
            </section>
            <section class="reg-footer d-flex align-items-center mt-3">
              <img src="../../assets/img/newkanban/greencircle.svg" />
              <div class="rounded-cirlces-font">
                Indicates active jobs and open positions.
              </div>
            </section>
          </section>
          <template v-else>
            <div class="d-flex align-items-center">
              <div class="newInt-rs-mainhead ml-2" style="width: 40%">
                Job details
              </div>
              <div style="width: 60%" class="position-relative">
                <div
                  class="w-100 d-flex align-items-center justify-content-end"
                >
                  <img
                    v-if="
                      (selectedJD.active &&
                        !selectedJD.closed &&
                        selectedJD.status !== '1' &&
                        selectedJD.approved &&
                        getCustomerDetail.lead) ||
                      getCustomerDetail.manager
                    "
                    @click="openModal(selectedJD, 'close')"
                    v-b-tooltip.hover.bottom="'Close Job'"
                    class="pointer mr-2"
                    src="../../assets/img/newworkbench/internalhiring/closejd.svg"
                    alt=""
                  />
                  <img
                    v-if="
                      selectedJD.active &&
                      !selectedJD.closed &&
                      selectedJD.status == '3' &&
                      (getCustomerDetail.lead || getCustomerDetail.manager)
                    "
                    @click="openModal(selectedJD, 'on-hold')"
                    v-b-tooltip.hover.bottom="
                      selectedJD.onHold ? 'Remove from On Hold' : 'On Hold'
                    "
                    class="pointer"
                    :src="
                      selectedJD.onHold
                        ? require('../../assets/img/newworkbench/internalhiring/remove-Onhold.svg')
                        : require('../../assets/img/newworkbench/internalhiring/moveTo-Onhold.svg')
                    "
                    alt=""
                  />
                  <div
                    class="ml-2 pointer"
                    v-if="
                      roles.includes('PUT_JOB') &&
                      selectedJD.active &&
                      !selectedJD.closed
                    "
                  >
                    <img
                      @click="goToEditJD(selectedJD)"
                      v-b-tooltip.hover.bottom="'Edit'"
                      class="imageshover"
                      src="../../assets/img/newworkbench/internalhiring/edit.svg"
                      alt=""
                    />
                  </div>
                  <div
                    class="ml-2 pointer"
                    v-else-if="
                      selectedJD.closed &&
                      (getCustomerDetail.lead || getCustomerDetail.manager)
                    "
                    v-b-tooltip.hover.top="'Re-Open'"
                    @click.stop="goToEditJD(selectedJD)"
                  >
                    <img
                      src="../../assets/img/newworkbench/internalhiring/re-open-jd.svg"
                      alt=""
                    />
                  </div>
                  <div
                    class="ml-2 pointer"
                    v-else-if="
                      !selectedJD.active && roles.includes('DELETE_JOB')
                    "
                    v-b-tooltip.hover.top="'Activate'"
                    @click.stop="goToEditJD(selectedJD)"
                  >
                    <img
                      src="../../assets/New-imgs/interviewProcess-icons/newInt-activateicon.svg"
                      alt=""
                    />
                  </div>
                  <div
                    class="ml-2 pointer"
                    v-if="
                      selectedJD.active &&
                      !selectedJD.closed &&
                      roles.includes('DELETE_JOB')
                    "
                  >
                    <img
                      @click="openModal(selectedJD, 'delete')"
                      v-b-tooltip.hover.bottom="'Delete'"
                      class="imageshover"
                      src="../../assets/img/newworkbench/internalhiring/delete.svg"
                      alt=""
                    />
                  </div>
                  <div class="ml-2 pointer" v-if="roles.includes('CLONE_JOB')">
                    <img
                      v-b-tooltip.hover.bottom="'Clone'"
                      @click="cloneJD(selectedJD)"
                      class="imageshover"
                      src="../../assets/img/newworkbench/internalhiring/cloneicon.svg"
                      alt=""
                    />
                  </div>
                  <div
                    class="ml-2 pointer"
                    v-if="
                      selectedJD.status === '3' &&
                      selectedJD.active &&
                      !selectedJD.closed &&
                      getCustomerDetail.lead &&
                      !roles.includes('EXTERNAL_ACCESS')
                    "
                    @click="openReassign(selectedJD)"
                  >
                    <img
                      v-b-tooltip.hover.bottom="'Re-Allocate'"
                      src="../../assets/img/newworkbench/internalhiring/reassignvr.svg"
                      alt=""
                    />
                  </div>
                  <div
                    class="ml-2 pointer"
                    v-if="
                      selectedJD.status == '3' &&
                      !selectedJD.closed &&
                      selectedJD.active
                    "
                    v-closable="{
                      handler: 'closeshareModal',
                      exclude: ['sharedLink', 'shareModal', 'deleteMail'],
                    }"
                  >
                    <img
                      @click="
                        (sharedModal = !sharedModal), (linkCopied = false)
                      "
                      v-b-tooltip.hover.bottom="'Share'"
                      src="../../assets/img/newcreatejob/share.svg"
                      alt=""
                    />
                  </div>
                </div>

                <div ref="shareModal" class="ihd-sharemodal" v-if="sharedModal">
                  <div
                    class="d-flex align-items-center justify-content-between"
                  >
                    <div class="ihd-share-head">Copy link to Share</div>
                    <div>
                      <img
                        class="pointer"
                        @click="closeshareModal"
                        src="../../assets/img/newcreatejob/x-close.svg"
                        alt=""
                      />
                    </div>
                  </div>
                  <div class="ihd-share-input d-flex align-items-center">
                    <div :style="!linkCopied ? 'width:92%' : 'width: 83%'">
                      <div class="w-100 text-truncate">
                        {{ sharedLink }}
                      </div>
                    </div>
                    <div
                      ref="sharedLink"
                      :style="!linkCopied ? 'width:25%' : 'width: 17%'"
                      class="d-flex justify-content-end"
                    >
                      <img
                        class="pointer"
                        v-if="!linkCopied"
                        @click="copyTheLink()"
                        src="../../assets/img/newcreatejob/copy.svg"
                        alt=""
                      />
                      <div
                        class="
                          ihd-share-copied-txt
                          d-flex
                          align-items-center
                          ml-1
                        "
                        v-else-if="linkCopied"
                      >
                        <img
                          src="../../assets/img/newcreatejob/copied.svg"
                          class="mr-1"
                          alt=""
                        />
                        Copied
                      </div>
                    </div>
                  </div>
                  <div class="mt-2 align-items-center d-flex ihd-share-head">
                    <span class="ihd-share-lines mr-2"></span>
                    OR
                    <span class="ihd-share-lines ml-2"></span>
                  </div>
                  <div>
                    <div class="ihd-share-head">Enter Email</div>
                    <div class="position-relative newmodalinputbox mt-1">
                      <b-form-input
                        autofocus
                        placeholder="Enter Email"
                        v-model.trim="shareEmail"
                        @keyup.enter="addEmail"
                        @keypress="validateEmail"
                        :class="{ error: $v.shareEmail.$error }"
                      >
                      </b-form-input>
                      <div class="hint-txt-kanban mt-1">
                        Press "Enter" to add email
                      </div>
                      <div
                        v-if="$v.shareEmail.$error"
                        class="hint-txt-kanban mt-1 text-danger"
                      >
                        Invalid Email
                      </div>
                      <div
                        v-else-if="$v.emailArray.$error"
                        class="hint-txt-kanban mt-1 text-danger"
                      >
                        Required
                      </div>
                    </div>
                    <div class="d-flex flex-wrap mt-2 ihd-gap email-container">
                      <div
                        class="
                          createjob-ip-evaluators
                          d-flex
                          align-items-center
                        "
                        v-for="(email, index) in emailArray"
                        :key="index"
                      >
                        {{ email }}
                        <img
                          ref="deleteMail"
                          src="../../assets/img/newcreatejob/interviewprocess/tagclose.svg"
                          class="ml-2 mt-1 pointer"
                          alt=""
                          @click="deleteEmail(index)"
                        />
                      </div>
                    </div>
                  </div>
                  <footer class="w-100 d-flex mt-3 justify-content-end bluebtn">
                    <b-button @click="sendLink" class="acs-addBtn-modal"
                      >Send</b-button
                    >
                  </footer>
                </div>
              </div>
            </div>
            <hr />
            <!-- class bind the below div wen continue to create is ter h-82 or h-90 -->
            <div
              class="ihd-jobdeatils overflow-auto"
              :style="
                selectedJD.status == '1' || selectedJD.closed
                  ? 'height: calc(100vh - 270px);'
                  : 'height:90%;'
              "
            >
              <div
                class="mt-3"
                v-for="(field, index) in filteredFields()[0]"
                :key="index"
              >
                <div class="newInt-rs-head">{{ field.label }}</div>

                <div v-if="checkFieldKeys(field)">-</div>
                <div
                  class="newInt-rs-subhead"
                  style="word-break: keep-all"
                  v-else-if="Object.keys(selectedJD).length > 0"
                >
                  <template v-if="isHtmlContent(field)">
                    <div v-html="checkValuesOfKey(field)"></div>
                  </template>
                  <template v-else>
                    {{ checkValuesOfKey(field) }}
                  </template>
                </div>
              </div>
              <div class="mt-3" v-if="filteredFields()[1].length != 0">
                <div
                  class="d-flex align-items-center pointer"
                  @click="showAdvanced = !showAdvanced"
                >
                  <img
                    v-if="!showAdvanced"
                    src="../../assets/img/newworkbench/internalhiring/advance.svg"
                    alt=""
                  />
                  <img
                    v-else
                    src="../../assets/img/newworkbench/internalhiring/advanceUp.svg"
                    alt=""
                  />
                  <span class="ihd-advance-text ml-2 mr-2">Advanced</span>
                  <hr />
                </div>
              </div>
              <template v-if="showAdvanced">
                <div
                  class="mt-3"
                  v-for="(field, index) in filteredFields()[1]"
                  :key="index + 'adv'"
                >
                  <div class="newInt-rs-head">{{ field.label }}</div>

                  <div v-if="checkFieldKeys(field)">-</div>
                  <div
                    class="newInt-rs-subhead"
                    style="word-break: keep-all"
                    v-else-if="Object.keys(selectedJD).length > 0"
                  >
                    <template v-if="isHtmlContent(field)">
                      <div v-html="checkValuesOfKey(field)"></div>
                    </template>
                    <template v-else>
                      {{ checkValuesOfKey(field) }}
                    </template>
                  </div>
                  <div
                    v-if="
                      !checkFieldKeys(field) &&
                      field.controlType == 'upload_file'
                    "
                    class="pointer"
                  >
                    <img
                      @click="downloadFile(field)"
                      class="ml-2"
                      src="../../assets/talentpool/tp_download_vc.svg"
                      alt=""
                    />
                  </div>
                </div>
                <hr v-if="positionInfo && positionInfo.length" />
              </template>
              <section
                v-if="positionInfo && positionInfo.length"
                class="mt-3 ihd-allocate-container"
              >
                <div class="ihd-allocate-maintxt">Position IDs</div>
                <div class="ihd-allocate-subhead">Allocated to you</div>
                <section
                  class="
                    ihd-jobstatus-approvals-container
                    ihd-jobstatus-approvals-width
                    mt-2
                    d-flex
                    ihd-gap
                    flex-wrap
                  "
                >
                  <div
                    v-for="(desc, i) in positionIDDesc"
                    :key="i"
                    class="d-flex align-items-center gap-8px"
                  >
                    <b-icon
                      icon="circle-fill"
                      font-scale="0.45"
                      :style="getAvatarStyle(desc.status)"
                    ></b-icon>
                    <div class="ihd-allocate-subhead text-body">
                      {{ desc.name }} ({{ positionStatusCount[desc.status] }})
                    </div>
                  </div>
                </section>
                <section class="d-flex ihd-gap flex-wrap mt-3">
                  <div
                    class="
                      drag-background drag-container
                      d-flex
                      align-items-center
                      gap-8px
                    "
                    v-for="(pos, index) in positionInfo"
                    :key="index"
                  >
                    <b-icon
                      icon="circle-fill"
                      font-scale="0.45"
                      :style="getAvatarStyle(pos.status)"
                    ></b-icon>
                    <div>{{ pos.positionID }}</div>
                  </div>
                </section>
              </section>
              <hr
                v-if="
                  (getCustomerDetail.lead &&
                    getThirdPartyData.configuration.jobApprovalStage ===
                      'BASIC_INFO' &&
                    selectedJD.preApproved) ||
                  (getCustomerDetail.manager && selectedJD.approved) ||
                  (getThirdPartyData.configuration.jobApprovalStage !==
                    'BASIC_INFO' &&
                    getCustomerDetail.lead)
                "
              />

              <!-- publish jobs -->
              <section
                class="mt-3 ihd-allocate-container"
                v-if="hasThreshold || hasPlatforms || hasNotifications"
              >
                <div class="ihd-allocate-maintxt">Publish Jobs</div>
                <div class="ihd-allocate-subhead">
                  This section outlines the publishing channels for your job
                  posting
                </div>
                <!-- Platforms Section -->
                <section v-if="hasPlatforms" class="w-100">
                  <div class="pubjobs-head fw-500 fs-14 my-3">Platform:</div>
                  <div class="d-flex flex-wrap w-100">
                    <template v-for="platform in platforms">
                      <div
                        v-if="platform.condition"
                        :key="platform.name"
                        class="
                          d-flex
                          align-items-center
                          fw-600
                          pubjobs-head
                          fs-13
                          w-50
                        "
                      >
                        <img class="h12w12" :src="platform.icon" alt="" />
                        <img
                          src="@/assets/publishJobs/line.svg"
                          class="mx-2"
                          alt=""
                        />
                        <div>{{ platform.label }}</div>
                      </div>
                    </template>
                  </div>
                  <hr />
                </section>

                <!-- Notifications Section -->
                <section v-if="hasNotifications" class="w-100">
                  <div class="pubjobs-head fw-500 fs-14 mb-2">
                    Notifications:
                  </div>
                  <div class="d-flex flex-wrap w-100">
                    <template v-for="note in notifications">
                      <div
                        v-if="note.condition"
                        :key="note.name"
                        class="
                          d-flex
                          align-items-center
                          fw-600
                          pubjobs-head
                          fs-13
                          w-50
                        "
                      >
                        <img class="h12w12" :src="note.icon" alt="" />
                        <div class="ml-2">{{ note.label }}</div>
                      </div>
                    </template>
                  </div>
                  <hr />
                </section>

                <!-- Threshold & Settings -->
                <section>
                  <div
                    v-if="hasThreshold"
                    class="pubjobs-head fw-500 fs-14 mb-2"
                  >
                    Applicants qualification threshold:
                    <span class="pubjobs-subheads fs-13 fw-600">
                      {{ selectedJD.customFields.threshold }}%
                    </span>
                  </div>

                  <div
                    v-if="
                      selectedJD.customFields.maxCheatingPercentage ||
                      selectedJD.customFields.maxCheatingPercentage == 0
                    "
                    class="pubjobs-head fw-500 fs-14 mb-3"
                  >
                    Minimum Assessment Cheating:
                    <span class="pubjobs-subheads fs-13 fw-600">
                      {{ selectedJD.customFields.maxCheatingPercentage }}%
                    </span>
                  </div>

                  <div
                    class="d-flex my-2"
                    :class="{
                      'align-items-baseline': selectedJD.customFields.automatic,
                    }"
                  >
                    <div>
                      <img
                        :src="
                          selectedJD.customFields.automatic ? greenTick : xMark
                        "
                        alt=""
                        class="h12w12"
                      />
                    </div>
                    <div class="pubjobs-head fw-500 fs-14 ml-1">
                      Do you want this recruitment process to be automated?
                      <span
                        class="position-relative"
                        @mouseenter="showTooltipPlace = 'first'"
                        @mouseleave="showTooltipPlace = null"
                      >
                        <img
                          src="@/assets/img/info-icon-publish.svg"
                          class="ml-2 pb-1"
                          alt=""
                        />
                        <span
                          v-if="showTooltipPlace == 'first'"
                          class="cs-tooltip-place"
                        >
                          <span class="mt-1">
                            Turn on to automate assessments and<br />
                            schedule interviews with Hire3x panelists,<br />
                            based on available credits.
                          </span>
                        </span>
                      </span>
                    </div>
                  </div>

                  <div
                    class="d-flex align-items-center mt-2"
                    :class="{
                      ' align-items-baseline':
                        selectedJD.customFields.manualReview,
                    }"
                  >
                    <img
                      :src="
                        selectedJD.customFields.manualReview ? greenTick : xMark
                      "
                      class="h12w12"
                      alt=""
                    />
                    <div class="pubjobs-head fw-500 fs-14 ml-1">
                      Manual Review of applications Required?
                    </div>
                    <div
                      @mouseenter="showTooltipPlace = 'second'"
                      @mouseleave="showTooltipPlace = null"
                      class="position-relative"
                    >
                      <img
                        src="@/assets/img/info-icon-publish.svg"
                        class="ml-2 pb-1"
                        alt=""
                      />
                      <div
                        v-if="showTooltipPlace == 'second'"
                        class="cs-tooltip-place"
                      >
                        <div class="mt-1">
                          Enable to manually move<br />
                          Hire3xAI-qualified candidates to<br />
                          Round 1 of the interview process.
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <!-- Interview Section -->
                <section v-if="selectedJD.customFields.automatic" class="mt-3">
                  <div class="pubjobs-head fw-500 fs-14">
                    No. of Interviews:
                    <span class="pubjobs-subheads fw-600 fs-13">
                      {{ selectedJD.customFields.noOfInterviews }} Interviews /
                      ₹{{ costPerInterview }} each
                    </span>
                  </div>
                  <div
                    class="
                      pubjobs-head
                      fw-500
                      fs-14
                      mt-2
                      d-flex
                      align-items-center
                    "
                  >
                    The interviews will take place on
                    <span
                      class="
                        pubjobs-subheads
                        text-capitalize
                        ml-2
                        d-flex
                        align-items-center
                      "
                    >
                      <img
                        :src="
                          selectedJD.customFields.meetingPlatform === 'vccl'
                            ? 'https://d33yrtc8qntbdn.cloudfront.net/Hire3xAssests/Logo/SVG/hire3xlogo.svg'
                            : require('@/assets/img/jddetails/teams.svg')
                        "
                        alt=""
                        class="mr-1"
                      />

                      <img
                        v-if="
                          selectedJD.customFields.meetingPlatform === 'vccl'
                        "
                        src="@/assets/publishJobs/line.svg"
                        class="mx-2"
                        alt=""
                      />
                      <span
                        :class="
                          selectedJD.customFields.meetingPlatform === 'vccl'
                            ? 'fw-400'
                            : 'fw-600'
                        "
                      >
                        {{
                          selectedJD.customFields.meetingPlatform === "vccl"
                            ? "VCCL"
                            : "Microsoft Teams"
                        }}
                      </span>
                    </span>
                  </div>
                </section>
              </section>
              <hr
                v-if="selectedJD.automatic || hasPlatforms || hasNotifications"
              />
              <template>
                <div
                  class="mt-3 ihd-allocate-container"
                  v-if="
                    (getCustomerDetail.lead &&
                      getThirdPartyData.configuration.jobApprovalStage ===
                        'BASIC_INFO' &&
                      selectedJD.preApproved) ||
                    (getCustomerDetail.manager && selectedJD.approved) ||
                    (getThirdPartyData.configuration.jobApprovalStage !==
                      'BASIC_INFO' &&
                      getCustomerDetail.lead)
                  "
                >
                  <div class="ihd-allocate-maintxt">Allocation</div>
                  <template>
                    <div class="mt-2">
                      <div class="ihd-right-deatils-heading">Recruiter(s)</div>
                      <div
                        class="ihd-right-detail-subheads mt-7px"
                        v-if="selectedJD.assignedTo.length"
                      >
                        {{ selectedJDRecruiters }}
                      </div>
                      <div class="ihd-right-detail-subheads mt-7px" v-else>
                        No recruiters are allocated
                      </div>
                    </div>
                    <hr />
                  </template>

                  <template>
                    <div class="mt-2">
                      <div class="ihd-right-deatils-heading">Panelist(s)</div>
                      <div
                        class="ihd-right-detail-subheads mt-7px"
                        v-if="selectedJD.assignedPanelist.length"
                      >
                        {{ selectedJDPanelist }}
                      </div>
                      <div
                        class="ihd-right-detail-subheads mt-7px"
                        v-else-if="selectedJD.showAllPanelist"
                      >
                        All panelists are allocated
                      </div>
                      <div
                        class="ihd-right-detail-subheads mt-7px"
                        v-else-if="
                          selectedJD.assignedPanelist.length == 0 &&
                          !selectedJD.showAllPanelist
                        "
                      >
                        No panelists are allocated
                      </div>
                    </div>
                    <hr />
                  </template>
                  <template>
                    <div class="mt-2">
                      <div class="ihd-right-deatils-heading">Vendor(s)</div>
                      <div
                        class="ihd-right-detail-subheads mt-7px"
                        v-if="selectedJD.vendor.length"
                      >
                        {{ selectedJDVendors }}
                      </div>
                      <div class="ihd-right-detail-subheads mt-7px" v-else>
                        No vendors are allocated
                      </div>
                    </div>
                  </template>
                </div>
                <hr
                  v-if="
                    (getCustomerDetail.lead &&
                      getThirdPartyData.configuration.jobApprovalStage ===
                        'BASIC_INFO' &&
                      selectedJD.preApproved) ||
                    (getCustomerDetail.manager && selectedJD.approved) ||
                    (getThirdPartyData.configuration.jobApprovalStage !==
                      'BASIC_INFO' &&
                      getCustomerDetail.lead)
                  "
                />
              </template>
              <template
                v-if="
                  selectedJD.interviewProcess &&
                  Object.keys(selectedJD.interviewProcess).length
                "
              >
                <div class="ihd-ip-container mt-3">
                  <div class="ihd-ip-mainhead">Interview Process</div>
                  <div
                    class="mt-3 d-flex w-100"
                    v-for="(interview, index) in selectedJDProcess"
                    :key="index + 'interview'"
                  >
                    <div class="position-relative">
                      <div class="ihd-ip-side-circle"></div>
                      <div
                        v-if="index < selectedJDProcess.length - 1"
                        class="ihd-ip-side-line"
                      ></div>
                    </div>
                    <div class="d-flex justify-content-between ml-3 w-90">
                      <div>
                        <div class="ihd-ip-main-head">
                          {{
                            interview.type === "f2f"
                              ? "Face to face"
                              : "Assessment"
                          }}
                        </div>
                        <div class="ihd-ip-sub-head">{{ interview.name }}</div>
                      </div>
                      <div>
                        <img
                          v-if="interview.type === 'f2f'"
                          src="../../assets/img/newworkbench/internalhiring/ipf2fround.svg"
                          alt=""
                        />
                        <img
                          v-else
                          src="../../assets/img/newworkbench/internalhiring/ipasmntround.svg"
                          alt=""
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <hr />
              </template>
              <div
                class="mt-3 ihd-allocate-container"
                v-if="getCustomerDetail.lead || getCustomerDetail.manager"
              >
                <div class="ihd-allocate-maintxt">Job status</div>
                <div
                  v-for="(activity, index) in selectedJD.activity"
                  :key="index + 'activitiy'"
                >
                  <div
                    class="
                      mt-2
                      ihd-right-deatils-heading
                      d-flex
                      justify-content-between
                      align-items-center
                    "
                  >
                    <div v-if="activity.movedTo === '2'">Job Created By:</div>
                    <div v-else>Updated By:</div>
                    <div>{{ formattedDate(activity.time, "dd-MM-yyyy") }}</div>
                  </div>
                  <div
                    class="d-flex align-items-center justify-content-between"
                  >
                    <div class="ihd-ip-sub-head w-50">{{ activity.name }}</div>
                    <div class="w-50 d-flex justify-content-end">
                      <div
                        class="
                          ihd-jobstatus-approvals-container
                          d-flex
                          align-items-center
                          p-1
                        "
                        style="width: fit-content"
                      >
                        <img
                          v-if="activity.movedTo === '2'"
                          src="../../assets/img/newworkbench/internalhiring/noti-sentfrapproval.svg"
                          alt=""
                        />
                        <img
                          v-else-if="activity.movedTo === '3'"
                          src="../../assets/img/newworkbench/internalhiring/accepted-tick.svg"
                          alt=""
                        />
                        <img
                          v-else-if="activity.movedTo === '4'"
                          src="../../assets/img/newworkbench/internalhiring/rejected-small.svg"
                          alt=""
                        />
                        <span class="ihd-jobstatus-noti-txt ml-2">{{
                          activity.status
                        }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <template>
              <div
                class="
                  ihd-footer-content
                  d-flex
                  justify-content-end
                  align-items-center
                "
                v-if="showContinueCreate"
              >
                <div class="newprimarybtn" @click="goToEditJD(selectedJD)">
                  <b-button class="padding-4-21">
                    <template v-if="selectedJD.closed">
                      <img
                        src="../../assets/img/newworkbench/internalhiring/re-open-job.svg"
                        alt=""
                        class="mr-2"
                      />
                    </template>
                    {{
                      selectedJD.closed ? "Reopen Job" : "Continue to Create"
                    }}
                  </b-button>
                </div>
              </div>
            </template>
          </template>
          <!-- <b-button class="acs-addBtn-modal mt-2">Continue to Create</b-button> -->
        </div>

        <!-- assign to vendor modal -->
        <b-modal
          id="reassignVendor"
          class="p-0"
          centered
          hide-footer
          hide-header
          size="lg"
          @hidden="closeReassignvendor()"
        >
          <div class="">
            <span class="caution-txt">{{
              vendorLength > 0 ? "Re-assign Vendor" : "Assign Vendor"
            }}</span>
          </div>
          <div class="line-work">
            <hr />
          </div>

          <div class="xMarkCancel" @click="closeReassignvendor()">
            <img src="../../assets/cross-round.svg" alt="" />
          </div>

          <div class="d-flex w-100">
            <div class="relativeclass pointer mt-2" style="width: 90%">
              <div class="fieldsetStyle">
                {{
                  vendorLength > 0 ? "Re-assign Vendor(s)" : "Assign Vendor(s)"
                }}&nbsp;<span class="asterik">*</span>
              </div>
              <div class="align-items-center pointer">
                <div
                  class="
                    dashboard-section-content
                    d-flex
                    justify-content-between
                  "
                  ref="vensinput"
                  @click="selectVendor(), (scoremodal = !scoremodal)"
                  placeholder="Select Vendor(s)"
                >
                  <div>
                    <span
                      class="dashboard-select-dropdown-text"
                      v-if="vendor.length != 0"
                    >
                      {{ vendor.length }} Vendors Selected
                    </span>
                    <span class="dashboard-select-dropdown-text" v-else>
                      Select vendors(s)..
                    </span>
                  </div>
                  <div @click="searchven = ''">
                    <img src="../../assets/downarrow.svg" alt="" />
                  </div>
                </div>

                <div
                  class="createjob-modal"
                  style="right: 0"
                  ref="vensdropdown"
                  v-if="scoremodal"
                  v-closable="{
                    exclude: ['vensdropdown', 'vensinput'],
                    handler: 'hidevendor',
                  }"
                >
                  <div class="relativeclass recinput">
                    <div class="dashboard-recsearchicon-pos">
                      <img
                        src="../../assets/img/accesscontrol/inputsearch.svg"
                        alt=""
                      />
                    </div>
                    <b-form-input
                      class="dashboard-inputField no-border"
                      type="search"
                      placeholder="Search"
                      v-model.trim="searchven"
                      debounce="500"
                      @update="resetCheckScroll"
                    >
                    </b-form-input>
                    <b-overlay :show="showSpinner" rounded="sm" opacity="1">
                      <div class="ihd-mode" @scroll="onVenScroll">
                        <b-form-group class="rec-dd-group">
                          <b-form-checkbox
                            class="
                              qb-dropdown-option-sing
                              text-break
                              pointer
                              m-1
                            "
                            size="sm"
                            v-for="(vend, index) in vendorDetails"
                            :key="index"
                            :value="{
                              vendorID: vend.vendorID,
                              vendorUserID: vend.vendorUserID,
                              email: vend.email,
                              name: vend.name,
                            }"
                            v-model="vendor"
                            name="flavour-4a"
                          >
                            {{ vend.name }}
                          </b-form-checkbox>
                          <div
                            style="margin: auto"
                            v-if="showCircleLoader"
                            class="d-flex justify-content-center"
                          >
                            <b-spinner label="Loading..."></b-spinner>
                          </div>
                        </b-form-group>
                      </div>
                      <div
                        v-if="vendorDetails.length == 0"
                        class="
                          folder-bar-head
                          mt-2
                          d-flex
                          justify-content-center
                        "
                      >
                        No Vendors found for "{{ searchven }}"
                      </div>
                    </b-overlay>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <b-button class="addbtn ml-3 mt-2" @click="reassignVendor()"
                >Assign</b-button
              >
            </div>
          </div>
          <div v-if="vendor.length != 0">
            <div class="mt-3 d-flex justify-content-between">
              <div class="assign-vendor-text">Assigned Vendors</div>
              <div class="total-vendor-text">
                Total Vendor’s :
                <span class="total-vendor-count-text"
                  >{{ selvendor.length }}
                </span>
              </div>
            </div>
            <hr />
            <div class="relativeclass recinput">
              <div class="dashboard-recsearchicon-pos">
                <img
                  src="../../assets/img/accesscontrol/inputsearch.svg"
                  alt=""
                />
              </div>
              <b-form-input
                class="dashboard-inputField no-border"
                type="search"
                placeholder="Search here"
                v-model="searchselven"
              >
              </b-form-input>
            </div>
          </div>
          <div
            class="ihd-mode-overflow"
            :style="
              scoremodal
                ? 'min-height: calc(100vh - 678px)'
                : 'min-height: auto'
            "
          >
            <div
              v-for="(i, index) in selvendor"
              :key="index"
              class="mt-2 d-flex justify-content-between select-vendor-bar"
            >
              <span
                class="p-2 select-vendor-text text-break"
                style="width: 93%"
              >
                {{ i.name }}
              </span>
              <span class="mr-2 p-2 pointer" @click="removevend(index)">
                <img
                  v-b-tooltip.hover.left="{
                    content: 'Remove Vendor',
                  }"
                  src="../../assets/removevendor.svg"
                  alt=""
                />
              </span>
            </div>
          </div>

          <div
            v-if="selvendor.length == 0 && searchselven != ''"
            class="folder-bar-head mt-2 d-flex justify-content-center"
          >
            No Vendors found for "{{ searchselven }}"
          </div>
          <div
            v-if="selvendor.length == 0 && searchselven == ''"
            class="folder-bar-head mt-2 d-flex justify-content-center"
          >
            No vendors assigned to this jd
          </div>
        </b-modal>

        <!-- Send Approval  modal -->
        <b-modal
          id="approval"
          centered
          hide-footer
          hide-header
          @hidden="$bvModal.hide('approval')"
        >
          <div
            class="
              modalheading
              d-flex
              align-items-center
              justify-content-between
            "
          >
            Send for Approval
          </div>
          <div @click="$bvModal.hide('approval')" class="xMarkCancel">
            <img src="../../assets/xmark.svg" alt="" />
          </div>
          <hr />
          <div class="mt-3">
            <span style="color: #8a8b8c"
              >Are you sure you want to send
              <span style="color: #545454"> "{{ delJob.title }}"</span> for
              approval ?</span
            >
          </div>

          <div class="d-flex align-items-center justify-content-end mt-3">
            <b-button @click="sendJdForApproval()" class="addbtn"
              >Confirm</b-button
            >
          </div>
        </b-modal>
        <!-- REopen Jd  modal -->
        <b-modal
          id="openjd"
          centered
          hide-footer
          hide-header
          @hidden="$bvModal.hide('openjd')"
        >
          <div
            class="
              modalheading
              d-flex
              align-items-center
              justify-content-between
            "
          >
            Reopen JD
          </div>
          <div @click="$bvModal.hide('openjd')" class="xMarkCancel">
            <img src="../../assets/xmark.svg" alt="" />
          </div>
          <hr />
          <div class="mt-3 text-break">
            <span style="color: #8a8b8c"
              >Are you sure you want to reopen
              <span style="color: #545454"> "{{ reopenjob.title }}" ?</span>
            </span>
          </div>

          <div class="d-flex align-items-center justify-content-end mt-3">
            <b-button
              @click="$bvModal.hide('openjd')"
              class="cancelbtn py-2 px-4"
              >Cancel</b-button
            >
            <b-button @click="reopenjd(reopenjob)" class="addbtn ml-2 py-2 px-4"
              >Confirm</b-button
            >
          </div>
        </b-modal>
      </div>
    </div>
    <CloseJobModal
      v-if="showCloseModal"
      :showCloseModal="showCloseModal"
      :deleteData="fromOnHold ? closejob : delDetails"
      :fromOnHold="fromOnHold"
      :type="actionType"
      :fromCloseModal="showDeleteModal"
      @close-modal="closeMainDeleteModal"
      @show-delete-modal="onCloseJobModal"
      @move-to-on-hold="moveToOnHold"
    />
    <UploadJDModal
      v-if="showUploadJD"
      :showModal="showUploadJD"
      @close-modal="showUploadJD = false"
      @parsed="goToNewJob($event)"
    />
    <DeleteJobModal
      v-if="showDeleteModal"
      :showDeleteModal="showDeleteModal"
      :deleteData="delDetails"
      :buttonLoader="buttonLoader"
      :fromClose="fromClose"
      :type="actionType"
      @delete-event="
        actionType == 'close' || fromClose ? closejd($event) : deleteJD($event)
      "
      @closeDeleteJd="showDeleteModal = false"
      @go-to-close="showCloseModal = true"
    />
    <FolderModal
      :showModal="showFolderModal"
      @close-modal="closeFolder"
      @save-recruiters="saveRecruiters"
    >
    </FolderModal>

    <CloneModal
      :cloneModal="cloneModal"
      :duplicatecloneName="duplicateCloneName"
      header="Clone Job"
      subHeader="New Job Name"
      placeholder="Enter Job Name"
      errorMessage="Job Name already exists"
      @closeCloneModal="closeCloneModal"
      @handle-clone="cloneJob"
      @change-duplicate-name="duplicateCloneName = false"
      :buttonLoader="buttonLoader"
      buttonName="Clone"
    />
    <ConfirmModal
      v-if="confirmModal"
      @closeModal="confirmModal = false"
      :confirmModal="confirmModal"
      @handle-submit="closejd"
      :button="buttonMsg"
      :header="headerMsg"
      :msg="headerContent"
      :imageSrc="computedImageSrc"
    />
  </div>
</template>
<script>
import { getAvatarStyle, filteredFields } from "@/controllers/commonHelpers.js";
import {
  required,
  maxLength,
  email,
  minLength,
} from "vuelidate/lib/validators";
import toast from "../../components/mixin/toast";

import { currentURL } from "../../utils/request.js";
import ListView from "../../components/internalhiring/ListView.vue";
import Spinner from "../../components/fixedcomponents/Spinner.vue";
import CloneModal from "../../views/InterviewProcess/cloneModal.vue";
import ConfirmModal from "../../views/InterviewProcess/ConfirmModal.vue";
import DeleteJobModal from "../../views/jobs/modals/DeleteJobModal.vue";
import CloseJobModal from "./modals/CloseJobModal.vue";
import UploadJDModal from "./modals/UploadJDModal.vue";
import FolderModal from "../../components/teamsmodal/FolderModal.vue";
import { mapGetters, mapActions } from "vuex";
import GridView from "../../components/internalhiring/GridView.vue";
import { getJobList } from "../../utils/apiClient/jobs";
import {
  updateDraft,
  getVendor,
  createJob,
  generatePositionIds,
  getCustomerFields,
  getRMList,
  deleteJobDesc,
  getSingleJob,
  generateShareLink,
  checkInterviews,
  sendLinkInEmail,
  getCreditsInfo,
} from "@/utils/apiFunctions.js";

import {
  checkFieldKeys,
  isHtmlContent,
  checkValuesOfKey,
} from "../../utils/customFields";
export default {
  mixins: [toast],
  components: {
    ListView,
    GridView,
    Spinner,
    FolderModal,
    CloneModal,
    DeleteJobModal,
    CloseJobModal,
    ConfirmModal,
    UploadJDModal,
  },
  data() {
    return {
      filterApplied: false,
      gridView: true,
      confirmModal: false,
      // NUMBERS
      venPage: 0,
      buttonMsg: "",
      headerMsg: "",
      shareEmail: "",
      closedModal: false,
      buttonLoader: false,
      sharedModal: false,
      linkCopied: false,
      reset: false,
      actionType: null,
      venPageEnd: null,
      totalVen: null,
      page: 0,
      count: 40,
      delDetails: {},
      total: 0,
      pageEnd: null,
      vendorLength: null,

      // BOOLEAN
      openFilter: false,
      sortCard: false,
      typeCard: false,
      duplicateCloneName: false,
      showAdvanced: false,
      showCircleLoader: true,
      showSpinner: false,
      showLoader: false,
      ven: false,
      scoremodal: false,
      LoaderStatus: false,
      showdetails: false,
      showsortcard: false,
      showfiltercard: false,
      showTooltip: false,
      rec: false,
      showjdtypecard: false,
      showFolderModal: false,
      showDeleteModal: false,
      fromClose: false,
      fromOnHold: false,
      showCloseModal: false,
      cloneModal: false,

      // STRINGS
      viewMoreJDIndex: null,
      selectedOption: "",
      sharedLink: "",
      searchven: "",
      searchselven: "",
      clonejobId: "",
      cloneTitle: "",
      clonedata: "",
      preview: "",
      filtertest: "",
      jobID: "",
      shareLink: "",
      toggleIconValue: "",
      statusType: "1",
      status: "",
      jdtypeselected: "Active",
      sortColumn: "updatedAt",
      sortOrder: "-1",
      sortSelected: "6",
      customerID: this.$route.params.customerID,
      customerName: null,
      costPerInterview: null,

      // ARRAYS
      selectedRMs: [],
      rmList: [],
      emailArray: [],
      positionInfo: [],
      advancedFields: [],
      normalFields: [],
      addJobToggle: false,
      showUploadJD: false,
      vendorDetails: [],
      jobList: [],
      vendor: [],
      values: [],
      delJob: [],
      closejob: [],
      reopenjob: [],
      sortOptions: [
        { text: "Name(Asce)", value: "1" },
        { text: "Name(Desc)", value: "2" },
        { text: "Date Created(Asce)", value: "3" },
        { text: "Date Created(Desc)", value: "4" },
        { text: "Date Modified(Asce)", value: "5" },
        { text: "Date Modified(Desc)(Default)", value: "6" },
      ],
      jdtypeoptions: [
        { text: "All", value: "All" },
        { text: "Active", value: "Active" },
        { text: "Inactive", value: "Inactive" },
        { text: "Closed", value: "Closed" },
        { text: "On Hold", value: "On Hold" },
        { text: "Not sent for approval", value: "Not sent for approval" },
        { text: "Sent For Approval", value: "Sent For Approval" },
        { text: "Accepted", value: "Accepted" },
        { text: "Published", value: "Published" },
        { text: "Not Published", value: "Not Published" },
        // { text: "Approved", value: "Approved" },
        { text: "IP setup for pending", value: "IP setup for pending" },
        { text: "Rejected", value: "Rejected" },
      ],
      positionIDDesc: [
        { name: "Active", status: 1 },
        { name: "Cancelled", status: 0 },
        { name: "Lost", status: 4 },
        { name: "Closed", status: 3 },
        { name: "On Hold", status: 2 },
      ],

      // OBJECTS
      customFields: null,
      selectedJD: null,
      positionStatusCount: {},
      cloneData: {
        title: "Clone Job",
        labelname: "New Job Name",
      },
      newData: {},
      singleCustomer: {},
      cloneResponse: {},
      JobDescription: {},
      editableJD: {},
      folderUpRec: {},
      recruiter: {
        recruitersoption: [],
        recruiter_Id: "",
        email: "",
        username: "",
        role: "",
        userID: "",
      },
      convertJSONtoString: function (user) {
        return JSON.stringify({
          username: user.username,
          email: user.email,
          roleName: user.roleName,
          roles: user.roles,
          isActive: user.isActive,
          userID: user.userID,
          landingPage: user.landingPage,
          folderID: user.folderID,
        });
      },
      greenTick: require("@/assets/publishJobs/greentick.svg"),
      xMark: require("@/assets/publishJobs/xmark.svg"),
      showTooltipPlace: null,
    };
  },

  created() {
    this.$store.commit("searchVUEX/saveSearchQuery", "");
    this.$store.commit("jobDescriptionVUEX/saveFeedBackObject", {});
    this.$store.commit("jobDescriptionVUEX/saveInterviewObject", {});
    this.$store.commit("jobDescriptionVUEX/saveAssesmentData", []);
    // Managing tab redirect based on JD type and Sort
    this.tabRedirect();
    this.customerName = this.getCustomerDetail.name;

    this.getCustomFields("1");
    this.getListOfRM();
    let gridViewData = String(this.$route?.query?.gridView);
    if (gridViewData === "true") {
      this.gridView = true;
    } else if (gridViewData === "false" || this.getCustomerDetail.manager) {
      this.gridView = false;
    }
    this.getCreditsInfo();
  },
  filters: {
    formatDate(dateStr) {
      const date = new Date(dateStr);
      const day = ("0" + date.getDate()).slice(-2);
      const month = ("0" + (date.getMonth() + 1)).slice(-2);
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    },
  },
  computed: {
    hasThreshold() {
      return (
        this.selectedJD.customFields.threshold != null ||
        this.selectedJD.customFields.threshold != undefined
      );
    },
    hasPlatforms() {
      return (
        this.selectedJD.openToPublic ||
        this.selectedJD.customFields.carrerPage ||
        this.selectedJD.customFields.naukri ||
        this.selectedJD.customFields.linkedIn
      );
    },
    hasNotifications() {
      return (
        this.selectedJD.customFields.mailNotification ||
        this.selectedJD.customFields.whatsAppNotification ||
        this.selectedJD.customFields.textNotification
      );
    },
    platforms() {
      return [
        {
          name: "openToPublic",
          label: "Job Platform",
          icon: require("@/assets/publishJobs/h3x.svg"),
          condition: this.selectedJD.openToPublic,
        },
        {
          name: "carrerPage",
          label: "Careers Page",
          icon: require("@/assets/publishJobs/h3x.svg"),
          condition: this.selectedJD.customFields.carrerPage,
        },
        {
          name: "linkedIn",
          label: "LinkedIn",
          icon: require("@/assets/publishJobs/linkedin.svg"),
          condition: this.selectedJD.customFields.linkedIn,
        },
        {
          name: "naukri",
          label: "Naukri",
          icon: require("@/assets/publishJobs/naukri.svg"),
          condition: this.selectedJD.customFields.naukri,
        },
      ];
    },
    notifications() {
      return [
        {
          name: "mailNotification",
          label: "Mail",
          icon: require("@/assets/publishJobs/mail.svg"),
          condition: this.selectedJD.customFields.mailNotification,
        },
        {
          name: "textNotification",
          label: "Text Message",
          icon: require("@/assets/publishJobs/txtmsg.svg"),
          condition: this.selectedJD.customFields.textNotification,
        },
        {
          name: "whatsAppNotification",
          label: "WhatsApp",
          icon: require("@/assets/publishJobs/whatsapp.svg"),
          condition: this.selectedJD.customFields.whatsAppNotification,
        },
      ];
    },
    filteredJdTypeOptions() {
      const options = this.jdtypeoptions || [];
      const stage = this.getThirdPartyData.configuration.jobApprovalStage;
      const { lead, manager } = this.getCustomerDetail;

      if (stage === "BASIC_INFO") {
        if (lead && (!manager || manager === null)) {
          return options.filter((opt) =>
            [
              "Active",
              "Published",
              "On Hold",
              "Closed",
              "Not Published",
              "IP setup for pending",
            ].includes(opt.text)
          );
        } else if (manager && lead) {
          return options.filter(
            (opt) => !["Not sent for approval", "Accepted"].includes(opt.text)
          );
        } else if (manager && !lead) {
          return options.filter(
            (opt) =>
              ![
                "IP setup for pending",
                "Not sent for approval",
                "Accepted",
              ].includes(opt.text)
          );
        }
      } else {
        return options.filter(
          (opt) =>
            !["IP setup for pending", "Not Published", "Published"].includes(
              opt.text
            )
        );
      }

      return options;
    },

    showContinueCreate() {
      const { selectedJD } = this;
      const { lead, manager } = this.getCustomerDetail;
      const config = this.getThirdPartyData.configuration;

      return (
        ((selectedJD.status === "1" || selectedJD.closed) &&
          lead &&
          config.jobApprovalStage !== "BASIC_INFO") ||
        (config.jobApprovalStage === "BASIC_INFO" &&
          lead &&
          !manager &&
          !selectedJD.approved) ||
        (config.jobApprovalStage === "BASIC_INFO" &&
          lead &&
          manager &&
          !selectedJD.approved &&
          selectedJD.preApproved) ||
        (config.jobApprovalStage === "BASIC_INFO" &&
          (lead || manager) &&
          selectedJD.closed)
      );
    },
    checkPermissionClone() {
      if (!this.roles.includes("CLONE_JOB")) return false;
      console.log(this.getCustomerDetail, "getCustomerDetail");

      const { lead, manager } = this.getCustomerDetail;
      return (
        (lead && manager == null) || (!lead && manager) || (lead && manager)
      );
    },
    checkPermissionDelete() {
      if (!this.roles.includes("DELETE_JOB")) return false;

      const { lead, manager } = this.getCustomerDetail;
      return (
        (lead && manager == null) || (!lead && manager) || (lead && manager)
      );
    },
    ...mapGetters("userVUEX", {
      getThirdPartyData: "getThirdPartyData",
    }),
    computedImageSrc() {
      const closeJobDelete = require("../../assets/img/newworkbench/internalhiring/closeJob-delete.svg");
      const moveJobHold = require("../../assets/img/newworkbench/internalhiring/moveJob-hold.svg");
      const moveJobActive = require("../../assets/img/newworkbench/internalhiring/moveJob-Active.svg");

      if (this.closedModal) {
        return closeJobDelete;
      }
      return !this.closejob.onHold ? moveJobHold : moveJobActive;
    },
    jobStatus() {
      const itype = this.$route.query.itype;
      switch (itype) {
        case "Inactive":
          return "Inactive";
        case "Not sent for approval":
          return "Not sent for approval";
        case "Accepted":
          return "Accepted";
        case "Rejected":
          return "Rejected";
        case "Sent For Approval":
          return "Sent For Approval";
        case "Closed":
          return "Closed";
        case "On Hold":
          return "On Hold";
        case "Published":
          return "Published";
        case "Active":
          return "Active";
        case "Not Published":
          return "Not Published";
        case "IP setup for pending":
          return "IP setup for pending";
        // case "Approved":
        //   return "Approved";
        default:
          return "";
      }
    },
    ...mapGetters("jobDescriptionVUEX", {
      customerDetail: "getCustomerDetail",
    }),
    headerContent() {
      if (this.closedModal) {
        return `Are you sure you want to close <span class="modalnamebluetext">"${this.closejob.title}"</span> job?`;
      }

      return this.closejob.onHold
        ? `Are you sure you want to move this job <span class="modalnamebluetext">"${this.closejob.title}"</span> Active from On-Hold?`
        : `Are you sure you want to move this job <span class="modalnamebluetext">"${this.closejob.title}"</span> to On-Hold?`;
    },
    selectedJDProcess() {
      if (Object.keys(this.selectedJD.interviewProcess).length) {
        const invalidRounds = [0, "F", "H", "R", "NI"];
        return this.selectedJD.interviewProcess.process.filter(
          (process) => !invalidRounds.includes(process.id)
        );
      } else {
        return [];
      }
    },
    selectedJDPanelist() {
      if (this.selectedJD.assignedPanelist.length) {
        let panelists = "";
        this.selectedJD.assignedPanelist.forEach(
          (panelist) => (panelists += panelist.username + ", ")
        );
        return panelists.substring(0, panelists.length - 2);
      } else {
        return "";
      }
    },
    selectedJDVendors() {
      if (this.selectedJD.vendor.length) {
        let vendors = "";
        this.selectedJD.vendor.forEach(
          (vendor) => (vendors += vendor.name + ", ")
        );
        return vendors.substring(0, vendors.length - 2);
      } else {
        return "";
      }
    },
    selectedJDRecruiters() {
      if (this.selectedJD.assignedTo.length) {
        let recruiters = "";
        this.selectedJD.assignedTo.forEach(
          (recruiter) => (recruiters += recruiter.username + ", ")
        );
        return recruiters.substring(0, recruiters.length - 2);
      } else {
        return "";
      }
    },
    isJdClosed() {
      return this.jdtypeselectedtext === "Closed";
    },
    ...mapGetters("jobDescriptionVUEX", {
      getCustomerDetail: "getCustomerDetail",
    }),

    selvendor() {
      return this.vendor.filter((vend) => {
        return (
          !this.searchselven ||
          vend.name.toLowerCase().includes(this.searchselven.toLowerCase())
        );
      });
    },
    ...mapGetters("userVUEX", {
      licenseKey: "getlicenseKey",
      rmConfig: "getRMConfig",
    }),
    ...mapGetters("jobDescriptionVUEX", {
      singleJdDetails: "getSingleJdDetails",
    }),
    ...mapGetters(["roles"]),
    ...mapGetters("searchVUEX", {
      searchQuery: "getSearchQuery",
    }),
    ...mapGetters("folderVUEX", {
      selectedUsersList: "getSelectedUsers",
      selectedFoldersList: "getSelectedFolderIDs",
    }),
    sortName() {
      if (this.sortSelected == "1") {
        return "Name(Asce)";
      } else if (this.sortSelected == "2") {
        return "Name(Desc)";
      } else if (this.sortSelected == "3") {
        return "Date Created(Asce)";
      } else if (this.sortSelected == "4") {
        return "Date Created(Desc)";
      } else if (this.sortSelected == "5") {
        return "Date Modified(Asce)";
      }
      return "Date Modified(Desc)";
    },
    jdtypeselectedtext() {
      if (
        this.getThirdPartyData.configuration.jobApprovalStage == "BASIC_INFO" &&
        this.jdtypeselected == "Active" &&
        this?.getCustomerDetail?.lead &&
        (!this?.getCustomerDetail?.manager ||
          this?.getCustomerDetail?.manager === null)
      ) {
        //eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.jdtypeselected = "Active";
        return "Active";
      } else if (this.jdtypeselected == "Active") {
        return "Active";
      } else if (this.jdtypeselected == "Inactive") {
        return "Inactive";
      } else if (this.jdtypeselected == "Closed") {
        return "Closed";
      } else if (this.jdtypeselected == "On Hold") {
        return "On Hold";
      } else if (this.jdtypeselected == "Not sent for approval") {
        return "Not sent for approval";
      } else if (this.jdtypeselected == "Sent For Approval") {
        return "Sent For Approval";
      } else if (this.jdtypeselected == "Accepted") {
        return "Accepted";
      } else if (this.jdtypeselected == "Rejected") {
        return "Rejected";
      } else if (this.jdtypeselected == "All") {
        return "All";
      } else if (this.jdtypeselected == "Published") {
        return "Published";
      } else if (this.jdtypeselected == "Not Published") {
        return "Not Published";
      } else if (this.jdtypeselected == "IP setup for pending") {
        return "IP setup for pending";
      }
      // else if (this.jdtypeselected == "Approved") {
      //   return "Approved";
      // }
      return "Active";
    },
    getIPName() {
      const ip = this.getCustomerDetail.name;
      if (ip.length <= 30) {
        return ip;
      } else {
        return ip.slice(0, 30) + "...";
      }
    },
  },
  watch: {
    searchQuery(newValue, oldValue) {
      if (newValue != oldValue) {
        if (newValue != "Loader") {
          this.LoaderStatus = true;
          this.page = 0;
          this.resetPagination();
        }
      }
    },
  },
  validations: {
    clonedata: {
      required,
      maxLength: maxLength(128),
    },
    emailArray: {
      required,
      minLength: minLength(1),
    },
    shareEmail: {
      email,
    },
  },
  methods: {
    async getCreditsInfo() {
      try {
        const res = await getCreditsInfo();
        if (res.status == 200) {
          this.costPerInterview = res.data.data.data.interviewCost;
        }
      } catch (error) {
        console.error(error);
      }
    },
    closeMainDeleteModal() {
      this.showCloseModal = false;
      this.fromOnHold = false;
      this.showDeleteModal = false;
      this.actionType = null;
    },
    moveToOnHold(option) {
      this.selectedOption = option;
      this.showDeleteModal = false;
      this.closejd();
    },
    onCloseJobModal() {
      this.fromOnHold = false;
      this.showCloseModal = false;
      this.showDeleteModal = true;
    },
    validateEmail() {
      this.$v.shareEmail.$touch();
    },
    async selectRM(id) {
      if (this.selectedRMs.includes(id)) {
        let index = this.selectedRMs.indexOf(id);
        this.selectedRMs.splice(index, 1);
      } else {
        this.selectedRMs.push(id);
      }
      await this.getJobs();
    },
    async getListOfRM() {
      try {
        let payload = {
          lead: this.getCustomerDetail.lead,
          customerID: this.$route.params.customerID,
        };
        const res = await getRMList(payload);
        if (res.status == 200) {
          this.rmList = res.data.data;
        }
      } catch (err) {
        console.log(err);
      }
    },
    getAvatarStyle(status) {
      return getAvatarStyle(status);
    },
    addEmail() {
      if (!this.$v.shareEmail.$invalid && this.shareEmail !== "") {
        this.emailArray.unshift(this.shareEmail.trim());
        this.emailArray = Array.from(new Set(this.emailArray));
        this.shareEmail = "";
      }
    },
    deleteEmail(index) {
      this.emailArray.splice(index, 1);
    },
    async sendLink() {
      this.$v.emailArray.$touch();
      if (!this.$v.emailArray.$invalid) {
        try {
          let payload = {
            jobID: this.selectedJD.jobID,
            trigggerOptions: ["email"],
            email: this.emailArray,
          };
          let res = await sendLinkInEmail(payload);
          if (res.status === 200) {
            this.successModal("Link shared successfully");
            this.closeshareModal();
          }
        } catch (error) {
          console.error(error);
        }
      }
    },
    async generateShareLink() {
      let data = {
        jobID: this.singleCustomer.jobID,
        customerID: this.singleCustomer.customerID,
      };
      try {
        const res = await generateShareLink(data);
        if (res.status == 200) {
          this.shareLink = await res.data.data.shareLink;
          this.$bvModal.show("sharelinkmodal");
        }
      } catch (error) {
        this.errorModal("Something went wrong!");
        return error;
      }
    },
    openReassign(job) {
      this.$router.push({
        name: "CreateJob",
        query: {
          jobID: job.jobID,
          type: "Edit",
          to: "allocate",
          customerName: this.$route.query.cardName,
          itype: this.jdtypeselected,
          isort: this.sortSelected,
          gridView: this.gridView,
        },
        params: {
          customerName: this.$route.query.cardName,
        },
      });
    },
    async addCloneJob(newJdTitle) {
      // Reset the form validation.

      this.$v.$reset();
      // Remove unnecessary fields from the cloned job response.
      delete this.cloneResponse.jobID;
      delete this.cloneResponse.createdBy;
      delete this.cloneResponse.createdAt;
      delete this.cloneResponse.groupID;
      delete this.cloneResponse.activity;
      delete this.cloneResponse.approved;
      delete this.cloneResponse.updatedAt;
      delete this.cloneResponse.preApproved;

      // Set default values for status and remarks fields.
      this.cloneResponse.status = "1";
      this.cloneResponse.closed = false;
      this.cloneResponse.remarks = "";

      // Set the title field of the cloned job response to the input value.
      this.cloneResponse.title = newJdTitle;

      // For PositionIDs
      this.cloneResponse.recruiterConfig.positionIDs = [];
      this.cloneResponse.assignedTo.forEach((recruiter) => {
        recruiter.positionIDs = [];
      });

      await this.generatePositionIds();

      const res = await createJob(this.cloneResponse);

      if (res.status == 200) {
        let toastText = `"${this.cloneTitle}"  has been cloned as "${this.cloneResponse.title} "`;
        this.dynamicToast("cloned-job", "Successfully cloned", toastText);
        this.buttonLoader = false;
        this.closeCloneModal();
        this.cloneResponse.title = "";
        newJdTitle = "";

        // Call the API to  get all the jobs

        this.getJobs();
        // Reset the input field and toggle icon.
        this.toggleIconValue = "";
        this.clonedata = "";
      } else if (res.status == 208) {
        this.duplicateCloneName = true;
        this.LoaderStatus = false;
        this.buttonLoader = false;
      } else {
        this.buttonLoader = false;
        this.LoaderStatus = false;
        // Show a generic error message if the API call fails.
        this.errorModal("Something went wrong!");
      }
    },
    async closejd(deleteData) {
      try {
        let payload = {
          customerID: this.closejob.customerID,
          jobID: this.closejob.jobID,
        };
        if (this.closedModal || deleteData) {
          payload.closed = true;
        } else {
          payload.onHold = !this.closejob.onHold;
        }
        if (deleteData) {
          payload.positionStatus = parseInt(deleteData.positionStatus);
          payload.comments = deleteData.comments;
        }
        this.LoaderStatus = true;
        const method = this.closedModal || deleteData ? "delete" : "patch";
        const response = await deleteJobDesc(payload, method);

        if (response.status === 200) {
          this.resetPagination();

          this.deselectJob(null);
          let toastAction =
            this.closedModal || deleteData
              ? "closed"
              : this.closejob.onHold
              ? "moved to Active"
              : "moved to On-Hold";
          let toastText = `"${this.closejob.title}" has been ${toastAction}.`;
          let toastMsg =
            this.closedModal || deleteData
              ? "closed-job"
              : this.closejob.onHold
              ? "success"
              : "success";
          this.dynamicToast(toastMsg, `Successfully ${toastAction}`, toastText);
          this.confirmModal = false;
        } else {
          this.errorModal("Something went wrong!");
          this.LoaderStatus = false;
        }
      } catch (err) {
        this.errorModal("Something went wrong!");
        this.LoaderStatus = false;
        throw err;
      }
      this.closeMainDeleteModal();
      this.$bvModal.hide("closejd");
    },

    deleteJD(deleteJobData) {
      let payload = {
        jobID: this.delDetails.jobID,
        customerID: this.delDetails.customerID,
        positionStatus: parseInt(deleteJobData.positionStatus),
        comments: deleteJobData.comments,
        automatic: true,
      };
      this.buttonLoader = true;
      this.$store
        .dispatch("jobDescriptionVUEX/deleteJobDesc", payload)
        .then((res) => {
          if (res.status == 200) {
            this.resetPagination();
            this.dynamicToast(
              "success",
              "Successfully deleted",
              `"${this.delDetails.title}" has been deleted successfully.`
            );
            this.deselectJob();
            this.showDeleteModal = false;
            this.buttonLoader = false;
          } else {
            this.errorModal("Something went wrong!");
          }
        })
        .catch((err) => {
          this.errorModal("Something went wrong!");
          throw err;
        });
      this.$bvModal.hide("deleteModal");
      this.toggleIconValue = "";
    },
    closeFolder() {
      this.$store.commit("folderVUEX/saveSelectedFolders", []);
      this.$store.commit("folderVUEX/saveSelectedUsers", []);
      this.$store.commit("folderVUEX/setActiveFolder", {});
      this.$store.commit("folderVUEX/setActiveFolderID", "");
      this.$store.commit("folderVUEX/setModalType", "");
      this.showFolderModal = false;
    },
    saveRecruiters() {
      this.editableJD.assignedTo = [];
      this.editableJD.userFolderIDs.Recruiters = [];
      this.selectedUsersList.forEach((user) =>
        this.editableJD.assignedTo.push(JSON.parse(user))
      );
      this.selectedFoldersList.forEach((folder) =>
        this.editableJD.userFolderIDs.Recruiters.push(folder)
      );
      this.$store.commit("folderVUEX/saveSelectedUsers", []);
      this.$store.commit("folderVUEX/saveSelectedFolders", []);

      this.showFolderModal = false;
      this.reassign();
    },
    async reassign() {
      try {
        const response = await updateDraft(this.editableJD);
        if (response.status == 200) {
          this.resetPagination();
          this.$store.commit(
            "jobDescriptionVUEX/editCurrentJobDesc",
            this.editableJD
          );

          let payload = {
            customerID: this.$route.params.customerID,
            type: this.statusType,
          };
          this.$store.dispatch("jobDescriptionVUEX/getJobDesc", payload);
          if (this.editableJD.assignedTo.length > 0) {
            this.successModal("Recruiters Assigned Successfully!");
          } else {
            this.successModal("JD not assigned to any recruiter");
          }
          this.editableJD = {};
        }
      } catch (error) {
        this.errorModal("Assigning recruiters failed");
        this.$store.dispatch(
          "jobDescriptionVUEX/getJobDesc",
          this.$route.params.customerID
        );
        throw new Error(
          `Failed! assigning recrtuiters ! status: ${error.status}`
        );
      }
    },

    reopenjd(data) {
      data.activateJD = true;
      this.$router.push({
        path: `/jobs/editjob/${data.jobID}`,
        query: {
          customerID: this.customerID,
          cardName: this.$route.params.cardName,
          activateJD: data.activateJD,
          gridView: this.gridView,
        },
      });
    },
    async generatePositionIds() {
      if (this.cloneResponse.openingsCount != null) {
        const payload = {
          noOfPositions: parseInt(this.cloneResponse.openingsCount),
          jobName: this.cloneResponse.title,
          customerName: this.customerName,
        };

        try {
          const result = await generatePositionIds(payload);
          if (result.status === 200) {
            this.cloneResponse.recruiterConfig.positionIDs =
              result.data.data.id;
          }
        } catch (error) {
          console.error("Error generating position IDs:", error);
        }
      }
    },
    async cloneJob(newJdTitle) {
      this.buttonLoader = true;
      try {
        this.LoaderStatus = true;
        let payload = {
          type: 2,
          jobID: this.clonejobId,
        };
        const res = await getJobList(payload);
        if (res.status == 200) {
          this.viewMoreJDIndex = null;
          this.cloneResponse = res.data.data;
          await this.addCloneJob(newJdTitle);
        } else {
          this.errorModal("Something went wrong!");
        }
      } catch (error) {
        throw new Error(`Failed! status:${error}`);
      }
    },
    closejdtype(data) {
      if (this.closedModal) {
        this.headerMsg = "Close Job";
        this.buttonMsg = "Close";
      } else {
        this.headerMsg = "On-Hold Job";
        this.buttonMsg = "Confirm";
      }
      this.closejob = data;
      this.confirmModal = true;
    },
    goToEditJD(job) {
      this.$router.push({
        name: "CreateJob",
        query: {
          jobID: job.jobID,
          itype: this.jdtypeselected,
          isort: this.sortSelected,
          type:
            job.status === "1" && job.preApproved
              ? "Edit"
              : job.status === "1"
              ? "Create"
              : !job.active
              ? "Activate"
              : job.closed
              ? "Re-Open"
              : "Edit",
          customerName: this.$route.query.cardName,
          gridView: this.gridView,
        },
        params: {
          customerName: this.$route.query.cardName,
        },
      });
    },
    closeCloneModal() {
      this.cloneResponse.title = "";
      this.cloneJobId = null;
      this.cloneTitle = null;
      this.cloneModal = false;
      this.duplicateCloneName = false;
    },
    cloneJD(job) {
      this.cloneResponse.title = "";
      this.clonejobId = job.jobID;
      this.cloneTitle = job.title;
      this.cloneModal = true;
    },
    closeModal(data) {
      this[data] = false;
    },
    openModal(job, type) {
      if (type == "on-hold" && job.onHold) {
        this.openCloseModal(true);
      } else {
        this.delDetails = job;
        if (this.delDetails.approved) {
          this.checkForInterviews(type);
        } else if (type == "delete") {
          this.fromClose = false;
          this.showDeleteModal = true;
        } else if (type == "on-hold") this.openCloseModal(true);
        else this.openCloseModal();
      }
    },
    openCloseModal(hold) {
      this.closedModal = hold ? false : true;
      this.closejdtype(this.selectedJD);
    },
    async checkForInterviews(type) {
      try {
        this.closejob = this.delDetails;
        let payload = {
          jobID: this.delDetails.jobID,
        };
        let res = await checkInterviews(payload);
        if (res.status === 200) {
          if (type == "on-hold") this.openCloseModal(true);
          else {
            this.actionType = null;
            this.fromClose = type == "close" ? true : false;
            this.showDeleteModal = true;
          }
        } else if (res.status === 409) {
          this.actionType = type;
          this.showCloseModal = true;
        }
      } catch (error) {
        console.error(error);
      }
    },
    hideFilterBox() {
      this.openFilter = false;
    },
    closeshareModal() {
      this.sharedModal = false;
      this.shareEmail = "";
      this.emailArray = [];
      this.$v.emailArray.$reset();
      this.$v.shareLink.$reset();
    },
    copyTheLink() {
      const textToCopy = this.sharedLink;

      navigator.clipboard
        .writeText(textToCopy)
        .then(() => {
          this.linkCopied = true;
          setTimeout(() => {
            this.linkCopied = false;
          }, 3000); // 3000 milliseconds = 3 seconds
        })
        .catch((err) => {
          console.error("Error in copying text: ", err);
        });
    },
    checkbetween(x, min, max) {
      // Return `true` if `x` is between `min` and `max`, otherwise `false`.
      return x > min && x < max;
    },
    resetFilter() {
      if (this.$route.query.isort || this.$route.query.itype) {
        this.jdtypeselected = this.$route.query.itype;
        this.sortSelected = this.$route.query.isort;
      }

      // this.status = this.$route.query.isort;
      if (this.reset == true) {
        this.statusType = "1";
        this.jdtypeselected = "Active";
        this.sortSelected = "6";
        this.status = "";
        this.saveSort();
        this.filterApplied = false;
      }
    },
    getJobDetails(job) {
      this.selectedJD = job;
      // Create a URL object to parse the current URL
      const url = new URL(currentURL);

      const baseURL = `${url.protocol}//${url.hostname}${
        url.port ? `:${url.port}` : ""
      }/`;
      this.sharedLink = `${baseURL}JobRegistration/${job.jobID}`;
      this.getpositionIDDetails(job.jobID);
      console.log(this.selectedJD, "view");
    },
    async getpositionIDDetails(jobID) {
      try {
        let payload = {
          type: 2,
          jobID: jobID,
          lead: this.customerDetail.lead,
        };
        const res = await getSingleJob(payload);
        if (res.status === 200) {
          this.positionInfo = res.data.data.positionInfo;
          this.positionStatusCount = res.data.data.positionStatusCount;
        }
      } catch (error) {
        console.error(error);
      }
    },
    deselectJob(job) {
      this.selectedJD = job;
    },
    hideAddJobToggle() {
      this.addJobToggle = false;
    },
    goToNewJob(parsedJD) {
      this.$router.push({
        name: "CreateJob",
        query: {
          type: "Create",
          customerName: this.customerName,
          itype: this.jdtypeselected,
          isort: this.sortSelected,
          wtype: this.$route.query.wtype,
          wsort: this.$route.query.wsort,
          gridView: this.gridView,
        },
        params: { parsedJD },
      });
    },
    tabRedirect() {
      if (this.$route.query.isort || this.$route.query.itype) {
        this.sortSelected = this.$route.query.isort;
        this.jdtypeselected = this.$route.query.itype;

        this.saveSort();
        return;
      }
      this.resetPagination();
    },
    resetPagination() {
      this.jobList = [];
      this.page = 0;
      this.LoaderStatus = true;
      this.showLoader = false;
      this.openFilter = false;
      this.singleCustomer = {};
      this.showdetails = false;
      this.selectedJD = null;
      this.viewMoreJDIndex = null;
      this.preview = "";
      this.getJobs();
    },
    saveSort() {
      this.LoaderStatus = true;
      this.status = "";
      if (this.sortSelected == "1") {
        this.sortColumn = "title";
        this.sortOrder = "1";
      } else if (this.sortSelected == "2") {
        this.sortColumn = "title";
        this.sortOrder = "-1";
      } else if (this.sortSelected == "3") {
        this.sortColumn = "createdAt";
        this.sortOrder = "1";
      } else if (this.sortSelected == "4") {
        this.sortColumn = "createdAt";
        this.sortOrder = "-1";
      } else if (this.sortSelected == "5") {
        this.sortColumn = "updatedAt";
        this.sortOrder = "1";
      } else {
        this.sortColumn = "updatedAt";
        this.sortOrder = "-1";
      }
      if (this.jdtypeselected == "All") {
        this.statusType = "2";
      } else if (this.jdtypeselected == "Active") {
        this.statusType = "1";
      } else if (this.jdtypeselected == "Inactive") {
        this.statusType = "0";
      } else if (this.jdtypeselected == "Closed") {
        this.statusType = "3";
      } else if (this.jdtypeselected == "On Hold") {
        this.status = "6";
      } else if (
        this.jdtypeselected == "Not sent for approval" ||
        this.jdtypeselected == "Not Published"
      ) {
        this.status = "5";
      } else if (this.jdtypeselected == "Sent For Approval") {
        this.status = "2";
      } else if (
        this.jdtypeselected == "Accepted" ||
        this.jdtypeselected == "Published"
      ) {
        this.status = "3";
      } else if (this.jdtypeselected == "Rejected") {
        this.status = "4";
      } else if (this.jdtypeselected == "IP setup for pending") {
        this.status = "1";
      } else {
        this.statusType = "1";
      }
      this.$router.push({
        name: `InternalHiringDashboard`,
        query: {
          ...this.$route.query,
          itype: this.jdtypeselected,
          isort: this.sortSelected,
          wtype: this.$route.query.wtype,
          wsort: this.$route.query.wsort,
        },
      });
      this.showjdtypecard = false;
      this.showsortcard = false;
      this.resetPagination();
    },
    setGridView(value) {
      this.gridView = value;
      this.deselectJob(null);
      this.$router.push({
        query: {
          ...this.$route.query,
          gridView: value,
        },
      });
    },
    gobackpointer() {
      if (this.$route.query.status == "Job") {
        this.$router.push({
          name: "MainDashboard",
        });
      } else {
        this.$router.push({
          name: `workBench`,
          query: {
            wtype: this.$route.query.wtype,
            wsort: this.$route.query.wsort,
          },
        });
      }
    },
    ...mapActions({
      getJobDesc: "jobDescriptionVUEX/getJobDesc",
    }),

    async getCustomFields(data) {
      try {
        let payload = {
          parentID: data,
        };
        const res = await getCustomerFields(payload);
        if (res.status == 200) {
          const customFields = res.data.data.fields;
          for (const field of customFields) {
            if (field.category === 1) {
              this.normalFields.push(field);
            } else {
              this.advancedFields.push(field);
            }
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    filteredFields() {
      return filteredFields(
        this.normalFields,
        this.advancedFields,
        this.selectedJD
      );
    },
    onScroll(e) {
      const { target } = e;
      if (
        Math.ceil(target.scrollTop) >=
        target.scrollHeight - target.offsetHeight
      ) {
        if (
          this.checkbetween(this.pageEnd, 0, this.total) &&
          !this.showLoader &&
          this.jobList.length
        ) {
          this.showLoader = true;
          this.page++;
          this.getJobs();
        }
      }
    },
    formattedDate(inputDate, format) {
      const date = new Date(inputDate);
      const day = date.getDate();
      const month = date.getMonth() + 1;
      const year = date.getFullYear();
      format = format.replace("MM", month.toString().padStart(2, "0"));
      if (format.indexOf("yyyy") > -1) {
        format = format.replace("yyyy", year.toString());
      } else if (format.indexOf("yy") > -1) {
        format = format.replace("yy", year.toString().substr(2, 2));
      }
      format = format.replace("dd", day.toString().padStart(2, "0"));
      return format;
    },
    checkFieldKeys(field) {
      return checkFieldKeys(field, this.selectedJD);
    },
    isHtmlContent(field) {
      return isHtmlContent(field, this.selectedJD);
    },
    checkValuesOfKey(field) {
      return checkValuesOfKey(field, this.selectedJD);
    },
    resetCheckScroll() {
      this.venPage = 0;
      this.vendorDetails = [];
      this.showSpinner = true;
      this.showCircleLoader = false;
      this.getVendors();
    },

    reAssignVendor(job) {
      this.$bvModal.show("reassignVendor");
      this.vendor = job.vendor;
      this.newData = job;
      this.resetCheckScroll();
    },

    hidevendor() {
      this.scoremodal = false;
    },
    async reassignVendor() {
      this.scoremodal = false;
      this.newData.vendor = this.vendor;
      try {
        const res = await updateDraft(this.newData);
        if (res.status == 200) {
          this.resetPagination();

          this.$store.commit(
            "jobDescriptionVUEX/editCurrentJobDesc",
            this.newData
          );
          let payload = {
            customerID: this.newData.customerID,
            type: this.statusType,
          };
          this.$store.dispatch("jobDescriptionVUEX/getJobDesc", payload);
          if (this.vendor.length > 0) {
            this.successModal("Vendors Assigned Successfully!");
          } else {
            this.successModal("JD not assigned to any Vendor");
          }
        }
      } catch (error) {
        this.errorModal("Assigning vendors failed");
        this.$store.dispatch(
          "jobDescriptionVUEX/getJobDesc",
          this.newData.customerID
        );
        throw new Error(
          `Failed! assigning recrtuiters ! status: ${error.status}`
        );
      }
      this.$bvModal.hide("reassignVendor");
    },
    // vendor functionality
    async getVendors() {
      try {
        let payload = {
          type: 1,
          searchQuery: this.searchven,
          sortColumn: "updatedAt",
          sortOrder: "-1",
          page: this.venPage,
          count: 10,
        };

        const res = await getVendor(payload);
        if (res.status == 200) {
          if (this.venPage == 0) {
            this.vendorDetails = res.data.data.data;
          } else {
            this.vendorDetails = [...this.vendorDetails, ...res.data.data.data];
          }
          this.showCircleLoader = res.data.data.total !== res.data.data.pageEnd;
        }
        this.totalVen = res.data.data.total;
        this.venPageEnd = res.data.data.pageEnd;
        this.showSpinner = false;
      } catch (error) {
        this.showSpinner = false;
        throw new Error(`Failed! status:${error.status}`);
      }
    },
    selectVendor() {
      this.ven = true;
    },
    hidevensoptions() {
      this.ven = false;
    },
    removevend(index) {
      this.vendor.splice(index, 1);
    },
    closeReassignvendor() {
      this.showLoader = false;
      this.searchven = "";
      this.scoremodal = false;
      this.$bvModal.hide("reassignVendor");
    },

    async getJobs() {
      const { customerID, lead, jobIDs, manager } = this.getCustomerDetail;
      try {
        let data = {
          type: this.statusType,
          sortBy: this.sortColumn,
          order: this.sortOrder,
          searchQuery: this.searchQuery,
          status: this.status,
          page: this.page,
          count: this.count,
          jobIDs,
          lead,
          customerID,
          manager,
        };

        if (
          this.getThirdPartyData.configuration.jobApprovalStage ===
            "BASIC_INFO" &&
          (this.jdtypeselectedtext == "Published" ||
            this.jdtypeselectedtext == "Not Published" ||
            this.jdtypeselectedtext == "IP setup for pending")
        ) {
          data.preApproved = true;
          data.type = "1";
        }
        if (this.jdtypeselectedtext == "Published") {
          data.status = "3";
        }
        if (
          data.status == "" ||
          (this.getThirdPartyData.configuration.jobApprovalStage ==
            "BASIC_INFO" &&
            this.jdtypeselectedtext == "Approved")
        ) {
          delete data.status;
        } else {
          data.type = "1";
        }
        if (data.searchQuery == "") {
          delete data.searchQuery;
        }
        if (data.status == "6") {
          data.type = "1";
          data.onHold = true;
          delete data.status;
        }
        const response = await getJobList(data);
        // Check if the response data is not empty
        if (response.status == 200) {
          this.deselectJob(null);
          if (response?.data?.data?.data?.length != 0) {
            let newRes = response.data.data.data;
            this.total = response.data.data.total;
            this.pageEnd = response.data.data.pageEnd;

            if (this.page == 0) {
              // If page value is 0, set response to  jobList
              this.jobList = response.data.data.data || [];
            } else {
              this.newRes = response.data.data.data;
              // If page value is not 0, concatenate newRes to jobList

              this.jobList = [...this.jobList, ...newRes];
            }
            this.showLoader = false;
            // this.showLoader =
            //   response.data.data.total !== response.data.data.pageEnd;

            this.LoaderStatus = false;
          }
        }
      } catch (error) {
        this.LoaderStatus = false;
        this.showLoader = false;
        throw new Error(`Failed! status:${error}`);
      }
      this.preview = "";
    },
    async sendJdForApproval() {
      this.delJob["status"] = "2";
      this.delJob["remarks"] = "";
      this.$bvModal.hide("approval");
      try {
        const response = await updateDraft(this.delJob);
        if (response.status == 200) {
          this.$store.commit(
            "jobDescriptionVUEX/editCurrentJobDesc",
            this.JobDescription
          );
          let payload = {
            customerID: this.$route.params.customerID,
            type: this.statusType,
          };
          this.$store.dispatch("jobDescriptionVUEX/getJobDesc", payload);
          this.successModal("JD has been sent for approval");
        }
      } catch (error) {
        this.errorModal("Send approval failed");
        this.$store.dispatch(
          "jobDescriptionVUEX/getJobDesc",
          this.$route.params.customerID
        );
        throw new Error(
          `Failed! assigning recrtuiters ! status: ${error.status}`
        );
      }
    },
  },
};
</script>

<style scoped>
.ihd-jobstatus-approvals-width {
  width: fit-content;
}

.addJobToggle-dropdown {
  position: absolute;
  top: 40px;
  right: 0px;
  background: #ffffff;
  box-shadow: 0px 1px 11px 0px #00000061;
  border-radius: 5px;
  padding: 10px;
  z-index: 8;
  width: 200px;
}

.addJobToggle-dropdown .unselOption {
  font-weight: 600;
  font-family: var(--lato);
  font-size: 13px;
  padding: 8px !important;
  color: #3a3c40;
  background: #ffffff;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.addJobToggle-dropdown .unselOption:hover {
  background: #e8eff4;
}

.drag-background {
  background: #d8d8d8;
}

.gap-8px {
  gap: 8px;
}

.ihd-gap {
  gap: 1rem;
}

.folder-bar-head {
  font-weight: var(--weight-M);
  font-size: 14px;
  color: #696969;
}

.intern-right-container {
  background: #ffffff;
  box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
  border-radius: 8px;
  width: 30%;
  margin-top: 15px;
  overflow: auto;
  height: calc(100vh - 164px);
}

.post-direct-container {
  background: #f8f8f8;
  border-radius: 10px;
  font-weight: 500;
  font-size: 13px;
  color: #696969;
  padding: 10px;
}

.jobstatuscard {
  position: absolute;
  top: 40px;
}

.ih-recinput .form-control {
  padding: 0.375rem 1.3rem !important;
}

.ih-recsearchicon-pos {
  position: absolute;
  top: 5px;
  left: 5px;
}

.ih-rec-dd-group {
  width: 100%;
  overflow-y: scroll;
}

.new-dd-group {
  height: 200px;
  overflow: auto;
}

.no-border {
  border: none;
  box-shadow: none;
  border-bottom: 1px solid rgba(114, 115, 142, 0.35);
}

.current-jd-name {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;

  color: #6d6d6d;
}

.dashboard-recsearchicon-pos {
  position: absolute;
  top: 5px;
  left: 10px;
}

.dashboard-inputField {
  font-weight: 400;
  font-size: 14px;
  padding: 0.5rem 0.5rem 0.5rem 1.75rem;
}

.total-vendor-text {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  /* identical to box height */
  color: #72738e;
}

.total-vendor-count-text {
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  /* identical to box height */
  color: #72738e;
}

.assign-vendor-text {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  /* identical to box height */

  color: #545454;
}

.select-vendor-bar {
  background: #f9f9f9;
}

.dashboard-select-dropdown-text {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;

  color: #696969;
}

.select-vendor-text {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;

  color: #696969;
}

.dashboard-section-content {
  padding: 5px;
  background: #fdfdfd;
  border: 0.7px solid rgba(10, 86, 200, 0.5);
  box-sizing: border-box;
  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.1);
  border-radius: 3px;
}

.delete-modal-title {
  font-weight: 500;
  font-size: 14px;
  color: #545454;
}

.delete-modal-body {
  font-weight: 400;
  font-size: 13px;
  color: #8a8b8c;
}

.ihd-mode {
  overflow: auto;
  min-height: auto;
  max-height: 250px;
}

.ihd-mode-overflow {
  overflow: auto;
  max-height: calc(100vh - 500px);
}

.cursor-default {
  cursor: default;
}

.mg-right-font-weight {
  font-weight: 600 !important;
}

.IP-rounds {
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  color: #696969;
}

.re-open-job {
  position: absolute;
  left: 10px;
}

.new-subcards {
  height: 73px;
  border-radius: 10px;
  background: rgba(32, 99, 155, 0.1);
  position: absolute;
  width: 90%;
  bottom: 10px;
}

/* regional manager right bar styles */
.clear-font {
  font-family: "Montserrat", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 17px;
  color: #20639b;
}

.reg-header {
  padding: 12px 16px;
  background: #e9f0f5;
  border-radius: 8px;
  font-family: "Montserrat", sans-serif;
  font-style: italic;
  font-weight: 400;
  font-size: 12px;
  line-height: 130%;
  color: #333333;
}

.reg-body-overflow {
  height: calc(100vh - 332px);
  overflow-y: auto;
  overflow-x: hidden;
}

.reg-footer {
  padding: 2px 6px;
  gap: 3px;
  background: #dce8f1;
  border-radius: 12px;
}

.reg-body {
  font-family: "Lato", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 130%;
  color: #272727;
}

.common-white-card .card-body {
  padding: 15px;
}

.common-selected-card .card-body {
  padding: 15px;
}

.rounded-cirlces-main {
  gap: 2px;
  padding: 2px 6px;
  border: 1px solid rgba(140, 140, 140, 0.3);
  border-radius: 12px;
}

.rounded-cirlces {
  border-radius: 12px;
  width: 10px;
  height: 10px;
  background: #038e00;
}

.rounded-cirlces-font {
  font-family: var(--lato);
  font-style: italic;
  font-weight: 400;
  font-size: 12px;
  line-height: 130%;
  color: #313131;
}

.common-white-card .card {
  border-radius: var(--size-10);
  width: 100%;
  box-shadow: 0px 4px 8px 0px #0000002b;
}

.common-white-card .card-body {
  padding: var(--size-10) var(--size-15);
  display: flex;
  align-items: center;
}

.common-selected-card .card {
  background: #e1eef7;
  border-radius: var(--size-10);
  width: 100%;
}

.common-selected-card .card-body {
  padding: var(--size-10) var(--size-15);
}
.view-toggle {
  background: #ffffff;
  border: 1px solid #e9f0f5;
  box-shadow: 0px 1px 5px rgba(0, 0, 0, 0.25);
  border-radius: 30px;
  padding: 0 1px;
}

.email-container {
  min-height: auto;
  max-height: 85px;
  overflow-y: auto;
}

.filter-drop-height {
  max-height: calc(100vh - 570px);
  min-height: auto;
  overflow: auto;
}
</style>
